require('../../../modules/es.array.includes');
var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('Array').includes;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/array/virtual/includes.js
// module id = 562
// module chunks = 0 1